import moment from "moment";
import { useReducer } from "react";
import trademarkStatisticsContext, { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import { ITrademarkStatisticsQuery } from "../../models/statistcs-trademark/query";

export interface IProps {
  children: React.ReactNode;
}
const TrademarkStatisticsContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.statisticsTrademark.getTrademarkStatisticsStatistics(state.query);

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };


  const setQuery = (query: ITrademarkStatisticsQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };


  return (
    <trademarkStatisticsContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          setQuery,
        },
      }}
    >
      {props.children}
    </trademarkStatisticsContext.Provider>
  );
};

export default TrademarkStatisticsContextProvider;
